import React from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import * as AppState from '../../AppState';
import Search from './Search/Search';
import PropertyTypeButton from './Filters/PropertyTypeButton/PropertyTypeButton';
import PriceRangeButton from './Filters/PriceRange/PriceRangeButton';
import BedsAndBathsButton from './Filters/BedsAndBaths/BedsAndBathsButton';
import AllFilters from './Filters/AllFilters/AllFilters';
import ButtonGroup from '../Shared/ButtonGroup';
import SortPropertyCardsDropdown from './Filters/SortPropertyCards/SortPropertyCardsDropdown';
import useResetAllFilters from '../Shared/ResetAllFilters';
import SavedSearchAlertButton from './SavedSearchAlert/SavedSearchAlertButton';
import './Navbar.scss';
import SavedHomeSearchButton from './SavedHomeSearch/SavedHomeSearchButton';
import OpenHouseButton from './Filters/OpenHouse/OpenHouseButton';

const Navbar = () => {
	const [rotateIcon, setRotateIcon] = React.useState(false);
	const [gsMobileView, setGsMobileView] = useRecoilState(AppState.gsMobileView);
	const gsIsMobile = useRecoilValue(AppState.gsIsMobile);
	const gsScreenWidth = useRecoilValue(AppState.gsScreenWidth);

	const gsFiltersActive = useRecoilValue(AppState.gsFiltersActive);

	const hideNavButtons = gsIsMobile || gsScreenWidth < 1058;

	const [resetAllFilters] = useResetAllFilters();

	// Rotate "Reset All" button icon
	const animateIcon = () => {
		setRotateIcon(true);
		setTimeout(() => setRotateIcon(false), 250);
	};

	const ResetFilters = ({ filtersApplied }: { filtersApplied: boolean }) => {
		return (
			<div
				id="resetAllFiltersWrapper"
				className={classNames(
					filtersApplied ? 'animation--fade-in' : '',
					'reset-all-filters__wrapper d-none d-lg-block col-auto flex-shrink-0 order-1 ps-2',
				)}
			>
				<button
					className="cc-btn cc-btn--sm cc-btn--flat cc-btn--secondary cc-btn--reset-text w-100 cc-btn--navbar"
					onClick={() => {
						animateIcon();
						resetAllFilters();
					}}
				>
					<FontAwesomeIcon icon={['far', 'sync']} className={classNames(rotateIcon ? ' spin-icon ' : '', 'ms-2 cc-btn__icon cc-btn__icon--prefix')} />
					Reset All
				</button>
			</div>
		);
	};


	return (
		<div className="home-search__navbar d-flex align-items-center justify-content-center justify-content-xl-start px-2 px-sm-3 px-lg-4 py-2">

			{/* FILTERS & SORT */}
			<div className="d-flex justify-items-between w-100">
				<div className="d-flex flex-wrap flex-lg-nowrap w-100">
					<Search />

					{gsIsMobile && (
						<ButtonGroup
							id="mobileMapToggle"
							options={[{ label: 'List' }, { label: 'Map' }]}
							activeButton={gsMobileView}
							buttonClass="home-search__shorten-button-height"
							callback={(option: string, index: number) => {
								setGsMobileView(index);
							}}
							wrapperClass="col-6 homesearch-filters__list-map-toggle-wrapper"
						/>
					)}

					<PropertyTypeButton wrapperClass="homesearch-filters__cc-btn-wrapper--property-type" />
					{!gsIsMobile && <PriceRangeButton />}
					{hideNavButtons
						? (
							<AllFilters
								hideNavButtons={hideNavButtons}
								gsIsMobile={gsIsMobile}
							/>
						) : (
							<React.Fragment>
								<BedsAndBathsButton />
                <OpenHouseButton/>
								<SortPropertyCardsDropdown id="homesearchPropertyListSortNav" />
								<AllFilters
									hideNavButtons={hideNavButtons}
									gsIsMobile={gsIsMobile}
								/>
							</React.Fragment>
						)
					}
					{!gsIsMobile && <SavedSearchAlertButton />}
					{!gsIsMobile && <SavedHomeSearchButton />}
				</div>

				{gsFiltersActive && <ResetFilters filtersApplied={gsFiltersActive} />}

			</div>
		</div>
	);
};

export default Navbar;

